import React from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { UserInScheduleWithPermissions } from "../../../../../../../interfaces/user";
import { useUsersStyles } from "../../../../../styles";
import EmptyState from "../../../../../../../Components/EmptyState";

type LinkedOrgansProps = {
  organs: UserInScheduleWithPermissions["orgaos"];
  userPermissions?: string[];
};

const LinkedOrgans: React.FC<LinkedOrgansProps> = ({ organs, userPermissions }) => {
  const { classes } = useUsersStyles();

  const isAdminAtendimento = userPermissions?.includes('Administrador de Atendimento');
  
  const atendimentoProfiles = ['Administrador de Atendimento', 'Gerente de Atendimento', 'Coordenador de Atendimento', 'Atendente'];
  
  const validProfiles = isAdminAtendimento 
    ? [...atendimentoProfiles, 'Administrador']
    : atendimentoProfiles;
  
  const filteredOrgans = organs?.filter(organData => 
    validProfiles.includes(organData.perfil)
  ) || [];

  return (
    <Paper elevation={3}>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableTH}>Perfil</TableCell>
              <TableCell className={classes.tableTH}>Órgão</TableCell>
              <TableCell className={classes.tableTH} />
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredOrgans.map((organData) => (
              <TableRow key={organData.orgao.id}>
                <TableCell className={classes.tableCell}>
                  {organData.perfil}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {organData.orgao.nome}
                </TableCell>
                <TableCell className={classes.tableCell} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!filteredOrgans.length && <EmptyState message="Nenhum órgão vinculado." />}
      </TableContainer>
    </Paper>
  );
};

export default LinkedOrgans;